import LibraryBookShelf from '@assets/library-book-shelf.webp'
import { Button } from '@/common/components/Button.tsx'
import { Link } from 'react-router-dom'
import { AppRoutePaths } from '@/routing/route_paths.ts'
import { useTranslation } from 'react-i18next'

export default function LandingPage() {
  const { t: translate } = useTranslation()

  return (
    <div className="grid grid-cols-2 h-full">
      <div className="hidden sm:block">
        <img
          alt="Your Company"
          src={LibraryBookShelf}
          className="h-full object-cover"
        />
      </div>
      <div className="flex flex-col py-4">
        <div className="mt-14 flex-grow flex flex-col bg-muted-white px-4 sm:px-6 lg:px-10 xl:mx-6">
          <h1 className="text-2xl">
            {translate('utah_fits_all_scholarship_program')}
          </h1>
          <h2 className="font-semibold text-4xl mt-1">
            {translate('qualifying_provider_application')}
          </h2>
          <p className="mt-10">
            {translate('qualifying_providers_classWallet')}
          </p>
          <p className="font-light text-gray-400 mt-10">
            {translate('application_must_be_completed')}
          </p>
          <Link to={AppRoutePaths.program_application.wizard.index}>
            <Button size="lg" className="font-bold max-w-52 mt-2">
              {translate('get_started')}
            </Button>
          </Link>
        </div>
        <footer className="px-4 sm:px-6 lg:px-8">
          <span className="text-sm text-gray-400">
            {translate('questions_fits_all_scholarship')}
          </span>
        </footer>
      </div>
    </div>
  )
}
